const zIndex = {
  modal: 2000,
  mainMenu: 1000,
  switchCameraIcon: 1000
};

export default zIndex;
